import Divider from "@material-ui/core/Divider";
import React,{ useEffect, useState } from "react";
import "./errands.css";
import ErrandComponent from "./errandComponent";
import { deleteErrands, getErrands } from "../../Data/Errands";

function Orders() {
  const [AllErrands, setErrands] = useState([]);

  useEffect(() => {
    const fetchErrands = async () => {
      const Errands = await getErrands();
      setErrands(
        Errands.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
    };
    return fetchErrands();
  }, [AllErrands]);

  return (
    <div className="errands_page">
      <h2>
        <center>Errands Placed</center>
      </h2>
      <hr height="10px" />
      <br />
      <br />
      {AllErrands.map((items, index) => {
        return (
          <>
            <ErrandComponent items={items} key={index} />
          </>
        );
      })}

      <br />
    </div>
  );
}

export default Orders;
